import { render } from "./ForgotPassword.vue?vue&type=template&id=27684a3d&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=27684a3d&lang=less&scoped=true"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27684a3d"]])

export default __exports__